import * as React from 'react';
import { useEffect, useState } from "react";

import './semaphore.css';

interface SemaphoreProps {
    value: number | null
    population?: string
}

export const Semaphore: React.FC<SemaphoreProps> = (props) => {

    const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
    
    // value ranges are ramdon, shoud be adjust to be seamless to real data recived.
    function getStatusFromValue(value : number, population?: string) {
        // For control population, invert the logic:
        // - High Bhattacharyya distance (different from control) = green (good)
        // - Low Bhattacharyya distance (similar to control) = red (concerning)
        if (population === 'control') {
          if (value <= 0.25) return 'red';
          if (value <= 0.50) return 'orange';
          if (value <= 0.75) return 'yellow';
          return 'green';
        }
        
        // For other populations (pathological/clinical):
        // - Low Bhattacharyya distance (similar to pathological) = red (concerning)
        // - High Bhattacharyya distance (different from pathological) = green (good)
        if (value <= 0.25) return 'green';
        if (value <= 0.50) return 'yellow';
        if (value <= 0.75) return 'orange';
        return 'red';
      }

    useEffect(() => {
      if (props.value !== null) {
        setSelectedStatus(getStatusFromValue(props.value, props.population));
      } else {
        setSelectedStatus(null);
      }
    }, [props.value, props.population]); 

    const statuses = ['green', 'yellow', 'orange', 'red'];
    
    function StatusDots({ selected }: { selected: string }) {
      return (
        <div className="status-dots ml-3">
          {statuses.map((status, index) => (
            <span
              key={index}
              className={`dot ${selected === status ? `active ${status}` : ''}`}
              title={status}
            />
          ))}
        </div>
      );
    }
    
    if (selectedStatus === null) { 
      return null
    };
    
    return  <StatusDots selected={selectedStatus}/> ;
}
